var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfoIIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "info-svgrepo-com",
    d: "M13.5,3.778A9.722,9.722,0,1,0,23.222,13.5,9.722,9.722,0,0,0,13.5,3.778ZM1,13.5A12.5,12.5,0,1,1,13.5,26,12.5,12.5,0,0,1,1,13.5ZM12.111,7.944A1.389,1.389,0,0,1,13.5,6.556h.014a1.389,1.389,0,0,1,0,2.778H13.5A1.389,1.389,0,0,1,12.111,7.944Zm.014,11.111a1.389,1.389,0,0,0,2.778,0V12.111a1.389,1.389,0,0,0-2.778,0Z",
    transform: "translate(-1 -1)",
    fill: "#ff8620",
    fillRule: "evenodd"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIIcon);
export default __webpack_public_path__ + "static/media/info-i-icon.a90b6f89a3dff0705f99b994d5f8fc05.svg";
export { ForwardRef as ReactComponent };